import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41825d50"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "経営情報報告制度（経営状況） 登録", -1))
const _hoisted_2 = {
  id: "keiei-jokyo-keisan-form",
  class: "p-1"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "施設選択")
], -1))
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "選択してください", -1))
const _hoisted_8 = ["value", "textContent"]
const _hoisted_9 = {
  key: 0,
  class: "border border-primary mt-3 p-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_keiei_jokyo_register_item = _resolveComponent("keiei-jokyo-register-item")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFacility) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFacilityChange && _ctx.onFacilityChange(...args))),
              disabled: _ctx.hasError
            }, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilityPicks, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t.facilityKey,
                  value: t,
                  textContent: _toDisplayString(t.hospitalClinicName)
                }, null, 8, _hoisted_8))
              }), 128))
            ], 40, _hoisted_6), [
              [_vModelSelect, _ctx.selectedFacility]
            ])
          ])
        ]),
        (_ctx.isShowRegisterItem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_keiei_jokyo_register_item, {
                "corporation-info": _ctx.corporationInfo,
                "facility-info": _ctx.facilityInfo,
                "keiei-jokyo-items": _ctx.keieiJokyoItems,
                "start-date": _ctx.accountingStartDate,
                "end-date": _ctx.accountingEndDate,
                onRegister: _ctx.onClickedRegister,
                onRecalculate: _ctx.onClickedRecalculate
              }, null, 8, ["corporation-info", "facility-info", "keiei-jokyo-items", "start-date", "end-date", "onRegister", "onRecalculate"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}